/* eslint-disable import/first */
import React from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import notLoggedInImg from './images/norating.svg';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import NoOrder from '../../components/NoOrder';

const NoFeedback = ({ callback, hist, navigateToExplore }) => {
  return (
    <Grid className={css.noOfferContainer}>
      <div className={css.title}>
        <div className={css.titleDesc}>
          {hist.length === 0 && (
            <div className={css.errorContainer}>
              <div className={css.errorText}>
                <FormattedMessage
                  id="feedback_noOrdersFound"
                  defaultMessage="Oops! 🤥 We can’t find any orders from this account 🙊"
                />{' '}
              </div>
              <div className={css.errorSubtext}>
                <FormattedMessage id="feedback_noOrder2" />
              </div>
            </div>
          )}
        </div>
      </div>
      <NoOrder
        callback={navigateToExplore}
        heading={
          <FormattedMessage
            id="no_rating_place_order"
            defaultMessage="Please place your first order now!"
          />
        }
        subHeading=""
        img={notLoggedInImg}
        isFeedback={true}
      />
    </Grid>
  );
};

export default NoFeedback;
